/* skin magic: "learn more about [product]" link under the price opens the founder video in the gallery.
   It switches the gallery to the video (the same as tapping its thumbnail) and brings it into view. It never starts playback;
   the shopper presses play, so nothing plays with sound on its own. */
(function () {
  function openVideo(link) {
    var root = link.closest('[data-sm-pdp]');
    if (!root) return false;
    var id = link.getAttribute('data-sm-video-link');
    var thumb = root.querySelector('[data-sm-thumb="' + id + '"]');
    var item = root.querySelector('[data-sm-media="' + id + '"]');
    if (!item) return false;
    if (thumb) {
      thumb.click();
      if (thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'center' });
    } else {
      item.hidden = false;
    }
    var stage = item.closest('.sm-gallery__stage') || item;
    var header = document.querySelector('.shopify-section-header-sticky, sticky-header');
    var offset = (header ? header.offsetHeight : 0) + 12;
    var top = stage.getBoundingClientRect().top;
    if (top < offset || top > window.innerHeight * 0.5) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, window.pageYOffset + top - offset), behavior: reduce ? 'auto' : 'smooth' });
    }
    var video = item.querySelector('video');
    if (video) {
      try { video.focus({ preventScroll: true }); } catch (e) { video.focus(); }
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-sm-video-link]');
    if (!link) return;
    if (openVideo(link)) e.preventDefault();
  });
})();
